// src/services/EmployeeService.js

import API from './api';

// Employee API Service
const EmployeeService = {
  // Create new employee
  createEmployee: async (employeeData) => {
    try {
      const res = await API.post('/api/employees', employeeData);
      return res.data;
    } catch (error) {
      console.error('Error creating employee:', error.response?.data || error.message);
      throw error;
    }
  },
  
  // Get all employees
  getAllEmployees: async () => {
    try {
      const res = await API.get('/api/employees');
      return res.data;
    } catch (error) {
      console.error('Error getting all employees:', error.response?.data || error.message);
      throw error;
    }
  },
  
  // Get employee by ID
  getEmployeeById: async (employeeId) => {
    try {
      const res = await API.get(`/api/employees/${employeeId}`);
      return res.data;
    } catch (error) {
      console.error('Error getting employee by ID:', error.response?.data || error.message);
      throw error;
    }
  },
  
  // Update employee by ID
  updateEmployee: async (employeeId, employeeData) => {
    try {
      const res = await API.put(`/api/employees/${employeeId}`, employeeData);
      return res.data;
    } catch (error) {
      console.error('Error updating employee:', error.response?.data || error.message);
      throw error;
    }
  },
  
  // Delete employee by ID
  deleteEmployee: async (employeeId) => {
    try {
      const res = await API.delete(`/api/employees/${employeeId}`);
      return res.data;
    } catch (error) {
      console.error('Error deleting employee:', error.response?.data || error.message);
      throw error;
    }
  }
};

export default EmployeeService;
